import { LINKAREER_CBT_DOMAIN, LINKBRARY_API_BASE_URL } from '../constant/urls';

/**
 * 링크브러리 로그아웃 URL 생성
 *
 * 링커리어에서 로그아웃할 때 링크브러리도 함께 로그아웃되도록 하는 URL을 생성합니다.
 * 링커리어 로그아웃 후 이 URL로 리다이렉트하면 링크브러리 로그아웃도 자동으로 처리됩니다.
 *
 * 플로우:
 * 1. 링커리어 로그아웃 처리
 * 2. 링크브러리 로그아웃 API 호출 (LINKBRARY_API_BASE_URL/auth/logout)
 * 3. 최종 목적지(finalRedirectUri)로 복귀 (기본값: CBT 도메인)
 *
 * @param finalRedirectUri 최종 리다이렉트할 주소 (기본값: CBT 도메인)
 * @returns 링크브러리 로그아웃 URL
 *
 * @example
 * // CBT 도메인으로 복귀하는 경우
 * getLinkbraryLogoutUrl('https://cbt.linkareer.com')
 * // => 'https://api.linkbrary.co.kr/auth/logout?redirectUri=https://cbt.linkareer.com'
 */
export const getLinkbraryLogoutUrl = (finalRedirectUri?: string): string => {
  const defaultRedirectUri = LINKAREER_CBT_DOMAIN;
  return `${LINKBRARY_API_BASE_URL}/auth/logout?redirectUri=${encodeURIComponent(
    finalRedirectUri || defaultRedirectUri
  )}`;
};
